import React, { Component } from 'react'

import './css/search.css'

export default class Search extends Component {

  componentWillReceiveProps(props) {
    if (this.props.section !== props.section) {
      this.input.value = ''
    }
  }

  render() {
    return (
      <div className="search">
        <input
          type        = "text"
          placeholder = {this.props.data.content.search_hint}
          ref         = {input => { this.input = input }}
          onChange    = {e => this.props.filter(e.target.value.toLowerCase())}
          className   = "search-input"
        />
        <div className="search-image" />
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/search.js